import api from "../api/api";

class EstadoService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/estado${q}`).then(r => r.data);
        } else {
            if (page) {
                return await api.get(`/estado?page=${page}`).then(r => r.data);
            } else {
                return await api.get(`/estado`).then(r => r.data);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/estado/${id}`).then(response => response.data);
    }

    async create(data: any) {
        return await api.post("/estado", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/estado/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/estado/${id}`).then(response => response.data);
    }
}

const estadoService = new EstadoService();
export default estadoService;